<template>
  <div class="vip-right">
    <img
      class="item-title"
      src="https://btw-common-data-oss.betterwestar.com/btw-admin/resource/ea12b35f5ee9a519ed5badc0bab7db6b_wh=789_141.png"
      alt=""
    />
    <div class="right-item" v-if="signInfo.pre_buy">
      <div class="title-text">会员提前购</div>
      <img
        class="image-item"
        :src="signInfo.pre_buy.image"
        v-buried
        :data-buried="'BG_VIP_HD_0YDK_SP_1_' + (activityId + 1)"
        v-clickBuried
        :data-click-buried="'CLICK_VIP_HD_0YDK_SP_1_' + (activityId + 1)"
        @click="bindJumpTo(signInfo.pre_buy.router)"
        alt=""
      />
    </div>
    <div class="right-item">
      <div class="title-text">更多会员福利</div>
      <div
        class="member-right-list"
        v-if="signInfo.more_welfare && signInfo.more_welfare.length"
      >
        <img
          class="image-item member-right-item"
          v-for="(item, index) in signInfo.more_welfare"
          :key="index"
          :src="item.image"
          v-buried
          :data-buried="
            'BG_VIP_HD_0YDK_SP_' + (index + 2) + '_' + (activityId + 1)
          "
          v-clickBuried
          :data-click-buried="
            'CLICK_VIP_HD_0YDK_SP_' + (index + 2) + '_' + (activityId + 1)
          "
          @click="bindJumpTo(item.router)"
          alt=""
        />
      </div>
      <div
        class="menu-container"
        v-if="signInfo.mall_config && signInfo.mall_config.length"
      >
        <div class="menu-item">
          <img
            class="image-item"
            :src="signInfo.mall_config[0].imageUrl"
            @click="bindJumpTo(signInfo.mall_config[0].route)"
            alt=""
          />
        </div>
        <div class="menu-item menu-item-right">
          <img
            class="image-item menu-item-image"
            :src="signInfo.mall_config[1].imageUrl"
            @click="bindJumpTo(signInfo.mall_config[1].route)"
            alt=""
          />
          <img
            class="image-item menu-item-image"
            :src="signInfo.mall_config[2].imageUrl"
            @click="bindJumpTo(signInfo.mall_config[2].route)"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    signInfo: {
      type: Object,
      default: null
    },
    activityId: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {}
  },
  created() {},
  methods: {
    bindJumpTo(router) {
      this.$betterwe.jumpRoute(router)
    }
  }
}
</script>
<style lang="scss" scoped>
.vip-right {
  padding: 0px 14px;
  margin-bottom: 13px;
  .item-title {
    width: 269px;
    height: 84px;
    object-fit: contain;
    margin: 0 auto;
  }
  .image-item {
    width: 100%;
  }
  .title-text {
    padding: 0px 14px;
    font-weight: bold;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.8);
    line-height: 22px;
    margin-bottom: 10px;
  }
  .right-item {
    background: linear-gradient(180deg, #fff4e3 0%, #ffd99b 100%);
    border-radius: 8px;
    padding: 10px 0px;
    margin-bottom: 10px;
  }
  .right-item:last-child {
    margin-bottom: 0;
  }
  .image-margin {
    margin-bottom: 10px;
  }
  .menu-container {
    display: flex;
    align-items: stretch;
    justify-content: center;
    padding: 0px 6px;
    .menu-item {
      margin-right: 6px;
      width: 163px;
      display: flex;
      align-items: stretch;
      flex-direction: column;
      justify-content: space-between;
      .menu-item-image {
        margin-bottom: 5px;
      }
      .menu-item-image:last-child {
        margin-bottom: 0;
      }
    }
    .menu-item-right {
      width: 170px;
    }
    .menu-item:last-child {
      margin-right: 0;
    }
  }
  .member-right-list {
    margin-bottom: 10px;
    .member-right-item {
      margin-bottom: 10px;
    }
    .member-right-item:last-child {
      margin-bottom: 0px;
    }
  }
}
</style>
